import Ajv from 'ajv';
import { deflate, inflate } from 'pako';

import { QUERY_BUILDER_SCHEMA } from 'bones/utils/queryBuilder/constants';
import { migrate } from 'bones/utils/queryBuilder/migrate/migrate';
import {
  AllQueryBuilder,
  QueryBuilder,
  QueryBuilderData,
} from 'bones/utils/queryBuilder/types';
import { uint8ArrayToUrl, urlToUint8Array } from 'bones/utils/urlConversion';

const ajv = new Ajv();
const queryBuilderValidator = ajv.compile(QUERY_BUILDER_SCHEMA);

/**
 * Encodes advanced search query to a string
 *
 * NOTE: The advanced search query param in the search url may have multiple `%3D` (encoded `=`).
 * These are padding characters for the base64 encoding. Do not remove them.
 */
export const encodeAdvancedSearch = (query: QueryBuilder): string | null => {
  try {
    const uncompressed = JSON.stringify(query);
    const u8 = deflate(uncompressed);
    const compressed = uint8ArrayToUrl(u8);
    return compressed;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const decodeAdvancedSearch = (
  compressed: string
): QueryBuilderData | null => {
  try {
    const u8 = urlToUint8Array(compressed);
    const uncompressed = inflate(u8, { to: 'string' });
    const result = JSON.parse(uncompressed || 'null');

    const isValid = queryBuilderValidator(result);
    if (!isValid) {
      console.error(result, queryBuilderValidator.errors);
      throw new Error('search data is invalid.');
    }

    const queryBuilder = result as AllQueryBuilder;
    return migrate(queryBuilder).data;
  } catch (err) {
    console.error(err);
    return null;
  }
};
